(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-quick-filter-buttons"] && !Shopify.designMode) return;
  try {
    if (!window.__cordQuickFilterInit) {
    window.__cordQuickFilterInit = true;
    const sectionPrefix = 'shopify-section-';
    const mobileStackQuery = window.matchMedia('(max-width: 749px)');

    const getScrollHint = (wrapper) =>
      wrapper.closest('.quick-collection-filter')?.querySelector('[data-scroll-hint]');

    const updateScrollHint = (wrapper, canScroll) => {
      const hint = getScrollHint(wrapper);
      if (!hint) return;
      const dismissed = wrapper.dataset.scrollHintDismissed === 'true';
      if (canScroll && !dismissed) {
        hint.hidden = false;
      } else {
        hint.hidden = true;
      }
    };

    const scrollActiveButtonIntoView = (wrapper) => {
      const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
      if (!scroller) return;
      const activeButton = scroller.querySelector('.quick-collection-filter__button.is-active');
      if (!activeButton) return;
      const buttonRect = activeButton.getBoundingClientRect();
      const scrollerRect = scroller.getBoundingClientRect();
      if (buttonRect.left < scrollerRect.left || buttonRect.right > scrollerRect.right) {
        activeButton.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    };

    const isStackedMobileLayout = (wrapper) => {
      const filter = wrapper.closest('.quick-collection-filter');
      if (!filter) return false;
      return filter.classList.contains('quick-collection-filter--stack-mobile') && mobileStackQuery.matches;
    };

    const evaluateScrollWrapper = (wrapper, shouldRevealActive = false) => {
      const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
      if (!scroller) return;
      if (isStackedMobileLayout(wrapper)) {
        wrapper.dataset.scrollable = 'false';
        wrapper.removeAttribute('data-scroll-hint-dismissed');
        updateScrollHint(wrapper, false);
        return;
      }
      const canScroll = scroller.scrollWidth - scroller.clientWidth > 1;
      if (canScroll) {
        wrapper.dataset.scrollable = 'true';
      } else {
        wrapper.dataset.scrollable = 'false';
        wrapper.removeAttribute('data-scroll-hint-dismissed');
      }
      updateScrollHint(wrapper, canScroll);
      if (shouldRevealActive) {
        scrollActiveButtonIntoView(wrapper);
      }
    };

    const initQuickFilterScrollWrappers = () => {
      document.querySelectorAll('.quick-collection-filter__scroll-wrapper').forEach((wrapper) => {
        const scroller = wrapper.querySelector('.quick-collection-filter__list--scroll');
        if (!scroller) return;
        const isFirstInit = wrapper.dataset.scrollInit !== 'true';
        wrapper.dataset.scrollInit = 'true';
        evaluateScrollWrapper(wrapper, isFirstInit);

        if (wrapper.dataset.scrollListenerBound === 'true') return;
        wrapper.dataset.scrollListenerBound = 'true';

        let scrollScheduled = false;
        scroller.addEventListener('scroll', () => {
          if (scrollScheduled) return;
          scrollScheduled = true;
          requestAnimationFrame(() => {
            evaluateScrollWrapper(wrapper);
            if (scroller.scrollLeft > 4) {
              wrapper.dataset.scrollHintDismissed = 'true';
            } else {
              wrapper.removeAttribute('data-scroll-hint-dismissed');
            }
            scrollScheduled = false;
          });
        });
      });
    };

    window.addEventListener('resize', () => initQuickFilterScrollWrappers());

    const renderQuickFilterSection = (sectionId, url) => {
      if (!sectionId || !url) return;

      const requestUrl = new URL(url, window.location.origin);
      requestUrl.searchParams.set('section_id', sectionId);

      fetch(requestUrl.toString())
        .then((response) => {
          if (!response.ok) {
            throw new Error('Section render failed');
          }
          return response.text();
        })
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const nextSection = doc.getElementById(`${sectionPrefix}${sectionId}`);
          const currentSection = document.getElementById(`${sectionPrefix}${sectionId}`);
          if (nextSection && currentSection) {
            currentSection.replaceWith(nextSection);
            initQuickFilterScrollWrappers();
          }
        })
        .catch(() => {
          window.location.assign(url);
        });
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-filter-url]');
      if (!trigger) return;

      if (
        event.defaultPrevented ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey ||
        event.button !== 0
      ) {
        return;
      }

      const url = trigger.dataset.quickFilterUrl || trigger.getAttribute('href');
      if (!url) return;

      const facetsForm = document.querySelector('facets-form-component');
      if (!(facetsForm && typeof facetsForm.updateFiltersByURL === 'function')) return;

      const sectionsWrapper = trigger.closest('[data-quick-filter-section]');
      const sectionId = sectionsWrapper?.dataset.quickFilterSection;
      const isSingleSelect = sectionsWrapper?.dataset.quickFilterSingleSelect === 'true';
      const groupParam = sectionsWrapper?.dataset.quickFilterParam;

      event.preventDefault();

      let destinationUrl = url;

      if (isSingleSelect && groupParam) {
        const parsedUrl = new URL(url, window.location.origin);
        parsedUrl.searchParams.delete(groupParam);
        if (!trigger.classList.contains('is-active')) {
          const value = trigger.dataset.quickFilterValue || '';
          parsedUrl.searchParams.append(groupParam, value);
        }
        parsedUrl.searchParams.delete('page');
        destinationUrl = parsedUrl.toString();
      }

      const filterContainer = trigger.closest('.quick-collection-filter');
      filterContainer?.classList.add('quick-collection-filter--loading');

      facetsForm.updateFiltersByURL(destinationUrl);

      if (sectionId) {
        renderQuickFilterSection(sectionId, destinationUrl);
      }
    });

    initQuickFilterScrollWrappers();
  }
  } catch(e) { console.error(e); }
})();

})();
